export enum ProductSortOrder {
    Newest = 1,
    Alphabet = 2,
    Cheapest = 3,
    MostExpensive = 4,
    MostRecentPictureAdded = 5,
}

export type ProductsParamsType = {
    SearchText?: string
    isExists?: boolean,
    OnlyNewestsLimit?: boolean,
    OnlyNewests?: boolean,
    Company?: Array<number>
    Car?: Array<number>
    Section?: Array<number>
    SortOrder?: ProductSortOrder,
    Page?: number,
    OnlyOffers?: boolean,
    OnlyOffersLimit?: boolean,
    OnlyWithPicture?: boolean,

}


export const defaultProductParams: ProductsParamsType = {
    Page: 1,
    SortOrder: ProductSortOrder.Alphabet,
    SearchText: "",
    isExists: false,
    Car: [],
    Section: [],
    Company: [],
    OnlyNewests: false,
    OnlyOffers: false,
    OnlyWithPicture: false,

}

